import React from "react";
import { PhoneArrowDownLeftIcon, PhoneArrowUpRightIcon, UserIcon } from "@heroicons/react/24/outline";

const features = [
  {
    name: "Recepción de llamadas",
    description:
      "Estadísticas avanzadas como número de llamadas recibidas, atendidas, no atendidas, gráficos temporales y mucho más.",
    icon: PhoneArrowDownLeftIcon,
  },
  {
    name: "Emisión de llamadas",
    description:
      "Estadísticas de rendimiento en la emisión de llamadas tanto automáticas como manuales.",
    icon: PhoneArrowUpRightIcon,
  },
  {
    name: "Monitor de agentes",
    description:
      "Estadísticas sobre el desempeño de los agentes de tu call-center.",
    icon: UserIcon,
  },
];

export default function FeaturesWithImage() {
  return (
    <div className="overflow-hidden bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-y-16 gap-x-8 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pr-8 lg:pt-4">
            <div className="lg:max-w-lg">
              <h2 className="text-lg font-semibold leading-8 tracking-tight text-orange-600">
                Siempre informado
              </h2>
              <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Conoce en tiempo real lo que está sucediendo en tu concesionario
              </p>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                Woice te permite tener el control y auditar todas las
                comunicaciones desde un Dashboard único
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-gray-900">
                      <feature.icon
                        className="absolute top-1 left-1 h-5 w-5 text-indigo-600"
                        aria-hidden="true"
                      />
                      {feature.name}
                    </dt>{" "}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <img
            src="capture_1.png"
            alt="Product screenshot"
            className="w-[21rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[47rem] md:-ml-4 lg:-ml-0"
            width={2432}
            height={1442}
          />
        </div>
      </div>
    </div>
  );
}
